export default __webpack_public_path__ + "static/media/memeda.a467594c.svga";